export default {
  // Text Panel
  '文本': '文字',
  '颜色': '顏色',
  '字体': '字體',
  '大写': '大寫',
  '字号': '字號',
  '背景色': '背景色',
  '圆角': '圓角',
  '内边距': '內邊距',
  '描边': '描邊',
  '对齐': '對齊',
  '底边距': '底邊距',
  '紧贴底边': '緊貼底邊',
  '垂直居中': '垂直居中',

  // Basic Panel
  '基础': '基本',
  '位置': '位置',
  '尺寸': '尺寸',
  '旋转': '旋轉',
  '居中': '居中',
  '原始尺寸': '原始尺寸',
  '平铺': '平鋪',
  '拉伸': '拉伸',
  '透明度': '透明度',
  '视频尺寸为{width}x{height}。': '影片尺寸為{width}x{height}。',
  '调整文本尺寸可能会改变文本展示效果，建议调整字体大小': '調整文字尺寸可能會改變文字展示效果，建議調整字體大小',

  // Library
  '视频': '影片',
  '音频': '音訊',
  '图片': '圖片',
  '新建文本': '新增文字',
  '花字库': '字體庫',
  '默认文本': '預設文字',

  // Export
  '导出': '匯出',

  // Tools
  '撤销': '復原',
  '重做': '取消復原',

  // Tooltips
  '清除选中': '清除選取',
  '删除当前选中': '刪除目前選取',
  '分割当前选中': '分割目前選取',
  '分割当前选中，只保留左侧': '分割目前選取，只保留左側',
  '分割当前选中，只保留右侧': '分割目前選取，只保留右側',
  '水平翻转': '水平翻轉',
  '将连续且相邻的素材拼接后下载': '拼接連續且相鄰的素材並下載',

  // Library
  '当前': '目前',
  '导入': '匯入',
  '全部': '全部',
  '删除': '刪除',
  '拖拽视频到这里': '拖曳影片到這裡',
  '拖拽音频到这里': '拖曳音訊到這裡',
  '拖拽图片到这里': '拖曳圖片到這裡',
  '或者点击上传': '或者點擊上傳',
  '暂无素材，请先导入素材': '暫無素材，請先匯入素材',

  // Manager
  '选择一个视频，开始你的创作。': '選擇一個影片，開始你的創作。',

  // Animation Panel
  '动画': '動畫',
  '入场动画': '入場動畫',
  '出场动画': '出場動畫',
  '关键帧动画': '關鍵幀動畫',
  '选择动画效果': '選擇動畫效果',
  '添加': '添加',
  '确定删除此动画？': '確定刪除此動畫？',
  '持续时间': '持續時間',
  '秒': '秒',
  '起始时间': '開始時間',
  '结束时间': '結束時間',
  '暂无动画，请添加动画效果': '暫無動畫，請添加動畫效果',

  // Animation Presets
  '淡入': '淡入',
  '从左滑入': '從左滑入',
  '从右滑入': '從右滑入',
  '从上滑入': '從上滑入',
  '从下滑入': '從下滑入',
  '放大进入': '放大進入',
  '旋转进入': '旋轉進入',
  '淡出': '淡出',
  '向左滑出': '向左滑出',
  '向右滑出': '向右滑出',
  '向上滑出': '向上滑出',
  '向下滑出': '向下滑出',
  '缩小退出': '縮小退出',
  '旋转退出': '旋轉退出',
  '脉冲': '脈衝',
  '抖动': '抖動',
  '弹跳': '彈跳',
  '摆动': '擺動',
  '闪烁': '閃爍',
  '自定义': '自訂',
  '起始状态': '起始狀態',
  '结束状态': '結束狀態',
  '位置 X': '位置 X',
  '位置 Y': '位置 Y',
  '缩放': '縮放',
  '旋转角度': '旋轉角度',
  '不透明度': '不透明度',

  // Filter Panel
  '可用滤镜': '可用濾鏡',
  '滤镜参数': '濾鏡參數',
  '选择滤镜': '選擇濾鏡',
  '请选择要编辑的滤镜': '請選擇要編輯的濾鏡',
  '强度': '強度',
  '请选择一个滤镜以调节参数': '請選擇一個濾鏡以調節參數',
  '灰度': '灰度',
  '模糊': '模糊',
  '亮度': '亮度',
  '对比度': '對比度',
  '饱和度': '飽和度',

  '无': '無',
  '入场': '入場',
  '出场': '出場',
  '动效': '動效',
  '结束位置': '結束位置',
  '使用当前时间轴上的当前时间点': '使用當前時間軸上的當前時間點',
  '开始位置': '開始位置',
  '当前有动画，调整可能不能直接看到效果，请播放片段查看': '當前有動畫，調整可能不能直接看到效果，請播放片段查看',
  '滤镜': '濾鏡',
  '恢复正在编辑的数据': '恢復正在編輯的數據',
  '转场': '轉場',
  '转场效果': '轉場效果',
  '点击应用': '點擊應用',
  '仅支持视频和图片': '僅支援影片和圖片',
  '删除转场': '刪除轉場',
  '已经存在视频转场，请先删除': '已存在影片轉場，請先刪除',
  '当前片段是轨道最后一个片段，不能应用转场效果': '當前片段是軌道最後一個片段，不能應用轉場效果',
  '暂无转场效果': '暫無轉場效果',
  '片段不存在': '片段不存在',
  '请先选择一个片段': '請先選擇一個片段',
  '轨道不存在': '軌道不存在',
  '默认': '預設',

  // 转场效果
  '淡入淡出': '淡入淡出',
  '滑动': '滑動',
  '百叶窗': '百葉窗',
  '溶解': '溶解',

  // Video/Audio Panel
  '音量': '音量',
  '请先选择视频片段': '請先選擇影片片段',
  '请先选择音频片段': '請先選擇音訊片段',
  '重置': '重置',

  // Advanced Export
  '高级导出': '高級匯出',
  '取消': '取消',
  '正在导出...': '正在匯出...',
  '导出完成！': '匯出完成！',
  '导出失败：': '匯出失敗：',
  '导出类型': '匯出類型',
  '输出格式': '輸出格式',
  '分辨率': '解析度',
  '帧率': 'FPS',
  '视频比特率': '影片位元率',
  '编码格式': '編解碼器',
  '包含音频': '包含音訊',
  '关闭时将导出无声音的视频': '關閉時將匯出無聲音的影片',
  '音频比特率': '音訊位元率',
  '比特率': '位元率',
  '采样率': '取樣率',
  '导出中...': '匯出中...',
  '开始导出': '開始匯出',
};